import { render, staticRenderFns } from "./FixedFieldsEditor.vue?vue&type=template&id=3bd4204d&scoped=true"
import script from "./FixedFieldsEditor.vue?vue&type=script&lang=js"
export * from "./FixedFieldsEditor.vue?vue&type=script&lang=js"
import style0 from "./FixedFieldsEditor.vue?vue&type=style&index=0&id=3bd4204d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4204d",
  null
  
)

export default component.exports